<template>
  <div class="about">
    <h1>Upcoming Events</h1>

<p>The list of events on the right side of every page of this site is generated by <a href="https://tabletop.events">Tabletop.Events</a>. You can include that list on your own site if you wish to help promote other Protospiel Events. Here's how:</p>

<p>Wherever you want the list to appear on your site, paste the following snippet of code:</p>

<p><code>
&lt;div id="upcomingevents"&gt;&lt;/div&gt;&lt;script src="//tabletop.events/tte1/js/protospiel.js"&gt;&lt;/script&gt;
</code></p>

<p>You may also wish to style it with some CSS. Here's a good start:</p>

<p><code>
&lt;style type="text/css" rel="stylesheet"&gt; #upcomingevents div { margin-bottom: 20px; } #upcomingevents a { font-size: 120%; }
&lt;/style&gt;
</code></p>

  </div>
</template>
